<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer005" role="doc-foreword">
<p class="pl-epigraph">For I know the thoughts that I think toward you, saith the Lord, thoughts of peace, and not of evil, to give you an expected end. </p>
<p class="pl-citation">—<em class="italic">Jeremiah</em> 29:11</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bible_Verse.vue?01725472